import { render, staticRenderFns } from "./FindTextView.vue?vue&type=template&id=3897fddf&scoped=true"
import script from "./FindTextView.vue?vue&type=script&lang=js"
export * from "./FindTextView.vue?vue&type=script&lang=js"
import style0 from "./FindTextView.vue?vue&type=style&index=0&id=3897fddf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897fddf",
  null
  
)

export default component.exports